import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as esAPI from '../../lib/api/esapi';
import * as stAPI from '../../lib/api/stapi';
import * as pdAPI from '../../lib/api/prodapi';
import { takeLatest } from 'redux-saga/effects';
import { findIndex, remove, forEach } from 'lodash';

// [START] API 서버에 Request ------------------------->

// 견적서 리스트 
const [
    REQ_TYPE_LIST_ES,
    REQ_TYPE_LIST_ES_SUCCESS,
    REQ_TYPE_LIST_ES_FAILURE,
] = createRequestActionTypes('esitem/LIST_ES');

// 견적서 삭제 
const [
    REQ_TYPE_DEL_ES,
    REQ_TYPE_DEL_ES_SUCCESS,
    REQ_TYPE_DEL_ES_FAILURE,
] = createRequestActionTypes('esitem/REQ_TYPE_DEL_ES');

const [
    REQ_TYPE_ITEM_ES,
    REQ_TYPE_ITEM_ES_SUCCESS,
    REQ_TYPE_ITEM_ES_FAILURE,
] = createRequestActionTypes('esitem/ITEM_ES');

const [
    REQ_TYPE_UPDATE_STATUS_ES,
    REQ_TYPE_UPDATE_STATUS_ES_SUCCESS,
    REQ_TYPE_UPDATE_STATUS_ES_FAILURE,
] = createRequestActionTypes('esitem/REQ_TYPE_UPDATE_STATUS_ES');

// 견적서 리스트 카운트 포함 (요청, 진행중, 완료)
const [
    REQ_TYPE_LIST_ES_ING,
    REQ_TYPE_LIST_ES_ING_SUCCESS,
    REQ_TYPE_LIST_ES_ING_FAILURE,
] = createRequestActionTypes('esitem/LIST_ES_ING');

// 견적서 리스트 카운트 비포함 (만료, 중단, 취소)
const [
    REQ_TYPE_LIST_ES_BEFORE,
    REQ_TYPE_LIST_ES_BEFORE_SUCCESS,
    REQ_TYPE_LIST_ES_BEFORE_FAILURE,
] = createRequestActionTypes('esitem/LIST_ES_BEFORE');

// 견적서 리스트 카운트 비포함 (만료, 중단, 취소) 더보기
const [
    REQ_TYPE_LIST_ES_BEFORE_ADD,
    REQ_TYPE_LIST_ES_BEFORE_ADD_SUCCESS,
    REQ_TYPE_LIST_ES_BEFORE_ADD_FAILURE,
] = createRequestActionTypes('esitem/LIST_ES_BEFORE_ADD');

// 견적서 리스트 카운트 비포함 (만료, 중단, 취소) 삭제요청
const [
    REQ_TYPE_DEL_ES_BEFORE,
    REQ_TYPE_DEL_ES_BEFORE_SUCCESS,
    REQ_TYPE_DEL_ES_BEFORE_FAILURE,
] = createRequestActionTypes('esitem/REQ_TYPE_DEL_ES_BEFORE');

const [
    REQ_ES_ST,
    REQ_ES_ST_SUCCESS,
    REQ_ES_ST_FAILURE,
] = createRequestActionTypes('esitem/REQ_ES_ST');

const [
    REQ_ES_PROD,
    REQ_ES_PROD_SUCCESS,
    REQ_ES_PROD_FAILURE,
] = createRequestActionTypes('esitem/REQ_ES_PROD');


// 견적서 주문 완료 리스트 
const [
    REQ_TYPE_LIST_ES_DONE,
    REQ_TYPE_LIST_ES_DONE_SUCCESS,
    REQ_TYPE_LIST_ES_DONE_FAILURE,
] = createRequestActionTypes('esitem/LIST_ES_DONE');

const [
    REQ_TYPE_LIST_ES_DONE_ADD,
    REQ_TYPE_LIST_ES_DONE_ADD_SUCCESS,
    REQ_TYPE_LIST_ES_DONE_ADD_FAILURE,
] = createRequestActionTypes('esitem/LIST_ES_DONE_ADD');

//견적서 상태 
const [
    REQ_TYPE_LIST_ES_STATUS,
    REQ_TYPE_LIST_ES_STATUS_SUCCESS,
    REQ_TYPE_LIST_ES_STATUS_FAILURE,
] = createRequestActionTypes('esitem/LIST_ES_STATUS');

// 견적서 check 처리 
const ES_ITEM_CHECK_ADD = 'esitem/ES_ITEM_CHECK_ADD';
const ES_ITEM_CHECK_DEL = 'esitem/ES_ITEM_CHECK_DEL';
const ES_ITEM_CHECK_ALLDEL = 'esitem/ES_ITEM_CHECK_ALLDEL';
const ES_ITEM_CHECK_ALLCHECK = 'esitem/ES_ITEM_CHECK_ALLCHECK';

const ES_ITEM_ING_CHECK_SET = 'esitem/ES_ITEM_CHECK_SET';
const ES_ITEM_BEFORE_CHECK_SET = 'esitem/ES_ITEM_BEFORE_CHECK_SET';

const ES_ITEMS_BEFORE_SET = 'esitem/ES_ITEMS_BEFORE_SET';
const ES_ITEMS_DEL_RESULT_RESET = 'esitem/ES_ITEMS_DEL_RESULT_RESET';
// 상태값 Reset
const ES_ITEM_RESET = 'esitem/ES_ITEM_RESET';

const ES_ITEM_INFO_RESET = 'esitem/ES_ITEM_INFO_RESET';

const ES_ITEM_SET_CUR_IDX = 'sitem/ES_ITEM_SET_CUR_IDX';
/**
 * 견적서 요청 Action - Container 에서 요청 
 * 첫번째 인자 - ActionType
 * 두번째 인자 - 리듀서에서 처리 해야 할 Payload : 스토어에서 사용될 값 (생략가능)
 */
export const reqEsItemListAction = createAction(REQ_TYPE_LIST_ES, (param) => {
    return ({ param });
});

export const delEsItemAction = createAction(REQ_TYPE_DEL_ES, (param) => {
    return ({ param });
});

export const reqEsItemAction = createAction(REQ_TYPE_ITEM_ES, (param) => {
    return ({ param });
});

export const updateEsItemStatusAction = createAction(REQ_TYPE_UPDATE_STATUS_ES, (es_rqst_id, status) => {
    return { es_rqst_id, status }
});

export const reqEsItemListIngAction = createAction(REQ_TYPE_LIST_ES_ING);

export const reqEsItemListDoneAction = createAction(REQ_TYPE_LIST_ES_DONE,(offset) => {
    return { offset }
});

export const reqEsItemListDoneAddAction = createAction(REQ_TYPE_LIST_ES_DONE_ADD,(offset) => {
    return { offset }
});

export const reqEsItemListBeforeAction = createAction(REQ_TYPE_LIST_ES_BEFORE, (offset) => {
    return { offset }
});

export const reqEsItemListBeforeAddAction = createAction(REQ_TYPE_LIST_ES_BEFORE_ADD, (offset) => {
    return { offset }
});

export const delEsItemBeforeAction = createAction(REQ_TYPE_DEL_ES_BEFORE, (param) => {
    return ({ param });
});

export const reqEsItemListStatusAction = createAction(REQ_TYPE_LIST_ES_STATUS);

export const reqEsStAction = createAction(REQ_ES_ST);
export const reqEsProdAction = createAction(REQ_ES_PROD);

export const addCheckItemAction = createAction(ES_ITEM_CHECK_ADD);
export const delCheckItemAction = createAction(ES_ITEM_CHECK_DEL);
export const allDellCheckItemAction = createAction(ES_ITEM_CHECK_ALLDEL);
export const allAddCheckItemAction = createAction(ES_ITEM_CHECK_ALLCHECK);

export const setIngCheckItemAction = createAction(ES_ITEM_ING_CHECK_SET);
export const setBeforeCheckItemAction = createAction(ES_ITEM_BEFORE_CHECK_SET);

export const setBeforeItemsAction = createAction(ES_ITEMS_BEFORE_SET);
export const resetDelResultItemsAction = createAction(ES_ITEMS_DEL_RESULT_RESET);
// 상태값 reset
export const resetItemStatus = createAction(ES_ITEM_RESET);

export const resetEsitemInfoAction = createAction(ES_ITEM_INFO_RESET);

export const setEsitemCurIdxAction = createAction(ES_ITEM_SET_CUR_IDX);

/**
 * SAGA API 에서 REST API 호출 
 */
const listEsItemsSaga = createRequestSaga(REQ_TYPE_LIST_ES, esAPI.listEsRequest);
const delEsItemsSaga = createRequestSaga(REQ_TYPE_DEL_ES, esAPI.delEsRequest);
const itemEsItemsSaga = createRequestSaga(REQ_TYPE_ITEM_ES, esAPI.getEsInfoView);
const updateEsItemStatusSaga = createRequestSaga(REQ_TYPE_UPDATE_STATUS_ES, esAPI.postUpdateEsStatus);
const listEsItemsIngSaga = createRequestSaga(REQ_TYPE_LIST_ES_ING, esAPI.getListEsIng);
const listEsItemsBeforeSaga = createRequestSaga(REQ_TYPE_LIST_ES_BEFORE, esAPI.getListEsBefore);
const listEsItemsBeforeAddSaga = createRequestSaga(REQ_TYPE_LIST_ES_BEFORE_ADD, esAPI.getListEsBefore);
const delEsItemsBeforeSaga = createRequestSaga(REQ_TYPE_DEL_ES_BEFORE, esAPI.delEsBeforeRequest);
const reqStEsListSaga = createRequestSaga(REQ_ES_ST, stAPI.getEsList);
const reqStProdListSaga = createRequestSaga(REQ_ES_PROD, pdAPI.getEsList);
const listEsItemsDoneSaga = createRequestSaga(REQ_TYPE_LIST_ES_DONE, esAPI.getListEsDone);
const listEsItemsDoneAddSaga = createRequestSaga(REQ_TYPE_LIST_ES_DONE_ADD, esAPI.getListEsDone);
const listEsItemsStatusSaga = createRequestSaga(REQ_TYPE_LIST_ES_STATUS, esAPI.getListEsStatus);

export function* esItemsSaga() {
    yield takeLatest(REQ_TYPE_LIST_ES, listEsItemsSaga);
    yield takeLatest(REQ_TYPE_DEL_ES, delEsItemsSaga);
    yield takeLatest(REQ_TYPE_ITEM_ES, itemEsItemsSaga);
    yield takeLatest(REQ_TYPE_UPDATE_STATUS_ES, updateEsItemStatusSaga);
    yield takeLatest(REQ_TYPE_LIST_ES_ING, listEsItemsIngSaga);
    yield takeLatest(REQ_TYPE_LIST_ES_BEFORE, listEsItemsBeforeSaga);
    yield takeLatest(REQ_TYPE_LIST_ES_BEFORE_ADD, listEsItemsBeforeAddSaga);
    yield takeLatest(REQ_TYPE_DEL_ES_BEFORE, delEsItemsBeforeSaga);
    yield takeLatest(REQ_ES_ST, reqStEsListSaga);
    yield takeLatest(REQ_ES_PROD, reqStProdListSaga);
    yield takeLatest(REQ_TYPE_LIST_ES_DONE, listEsItemsDoneSaga);
    yield takeLatest(REQ_TYPE_LIST_ES_DONE_ADD, listEsItemsDoneAddSaga);
    yield takeLatest(REQ_TYPE_LIST_ES_STATUS, listEsItemsStatusSaga);
}
// [END] API 서버에 Request ------------------------------>


// 견적 요청에서 패키지 상품정보 
const REQ_TYPE_SET_PACKAGE_PRODS = 'es/PACKAGE_PRODS';
export const setReqProdInfoAction = createAction(REQ_TYPE_SET_PACKAGE_PRODS);

// 견적 체크값
export const esitem_check_info = {
    es_rqst_id : null,
    rqst_status : null,
    es_pay_price: null,
}

/**
 * Store에 저장될 값 
 */
const initialState = {
    esListResult: null,
    esItems: null,          //견적 요청. 견적완료
    error: null,
    reqProdItems: [],
    esItemCheck: [],

    esItemInfo: null,       
    esItemInfoRes: null,

    esStatusRes:null,

    esListBeforeResult: null, //견적 삭제 가능한 것들 요청
    esItemsBefore: null,

    esItemCheckBefore: [],

    esDelListBeforeResult: null,

    esStItems: [],              //공간
    esProdItems: [],            //베스트 상품

    esListDoneResult: null, //주문 완료 견적
    esItemsDone: null,
    esItemsDoneCount: 0,

    curIdx: 0, //탭 인덱스

    esItemsStatus: null, //견적 리스트 전체 상태
}

const esItemsReducer = handleActions(
    {
        [REQ_TYPE_LIST_ES_SUCCESS]: (state, { payload }) => {

            //console.log("data = " + JSON.stringify(payload.data))
            state.esListResult = payload.code;
            state.esItems = payload.data;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_LIST_ES_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_DEL_ES_SUCCESS]: (state, { payload }) => {

            state.esListResult = payload.code;
            state.esItems = payload.data;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_DEL_ES_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),

        [REQ_TYPE_SET_PACKAGE_PRODS]: (state, { payload: reqProdItems }) => ({
            ...state,
            reqProdItems,
        }),
        [ES_ITEM_CHECK_ADD]: (state, { payload }) => {

            let idx = findIndex(state.esItemCheck, (curitem) => {
                return curitem === payload;
            })

            if (idx === -1) {
                state.esItemCheck.push(payload);
            }
            return ({
                ...state,
            })
        },
        [ES_ITEM_CHECK_DEL]: (state, { payload }) => {

            remove(state.esItemCheck, (curitem) => {
                return curitem === payload;
            })

            return ({
                ...state,
            })
        },
        [ES_ITEM_CHECK_ALLDEL]: (state) => {
            state.esItemCheck = [];
            return ({
                ...state,
            })
        },
        [ES_ITEM_CHECK_ALLCHECK]: (state) => {

            state.esItemCheck = [];
            forEach(state.esItems, (curitem) => {
                state.esItemCheck.push(curitem[0].es_rqst_id);
            })
            return ({
                ...state,
            })
        },
        [ES_ITEM_RESET]: (state) => {
            return ({
                ...state,
                esListResult: null,
                esItems: null,
                error: null,
                reqProdItems: [],
                esItemCheck: [],
                esItemCheckBefore: [],
            })
        },
        [REQ_TYPE_ITEM_ES_SUCCESS]: (state, { payload }) => {
            state.esItemInfoRes = payload.code;

            if (payload.code === 600 || payload.code === 500) {
                state.esItemInfo = null;
            } else {
                state.esItemInfo = payload.data;
            }

            return ({
                ...state,
            })
        },
        [REQ_TYPE_ITEM_ES_FAILURE]: (state, { payload: error }) => {
            // state.esItemInfoRes = null;
            // state.esItemInfo = null;
            return ({
                ...state,
                error,
            })

        },
        [ES_ITEM_INFO_RESET]: (state) => {
            return ({
                ...state,
                esItemInfo: null,
                esItemInfoRes: null,
                esStatusRes:null,
            })

        },
        [REQ_TYPE_UPDATE_STATUS_ES_SUCCESS]: (state, { payload }) => {

            //console.log("data = " + JSON.stringify(payload.data))
            state.esStatusRes = payload.code;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_UPDATE_STATUS_ES_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_LIST_ES_ING_SUCCESS]: (state, { payload }) => {
            //console.log("REQ_TYPE_LIST_ES_ING_SUCCESS");
            //console.log("data = " + JSON.stringify(payload.data))
            state.esListResult = payload.code;
            state.esItems = payload.data;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_LIST_ES_ING_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_LIST_ES_BEFORE_SUCCESS]: (state, { payload }) => {

            //console.log("before data = " + JSON.stringify(payload.data))
            //console.log("REQ_TYPE_LIST_ES_BEFORE_SUCCESS");
            state.esListBeforeResult = payload.code;
            state.esItemsBefore = payload.data;
            state.esDelListBeforeResult = null;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_LIST_ES_BEFORE_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_LIST_ES_BEFORE_ADD_SUCCESS]: (state, { payload }) => {
            //console.log("REQ_TYPE_LIST_ES_BEFORE_ADD_SUCCESS");
            //console.log("before data = " + JSON.stringify(state.esItemsBefore))
            state.esDelListBeforeResult = null;
            state.esListBeforeResult = payload.code;
            //state.esItemsBefore = payload.data;

            let dataList = state.esItemsBefore.items.concat(payload.data.items);
            let data = Object.assign({}, state.esItemsBefore);
            data.items = [];
            data.totalcount = payload.data.totalcount;
            Object.assign(data.items, dataList);
            //console.log("after data = " + JSON.stringify(data));
/* 
            let dataList = state.brandInfo.dataList.concat(brandInfo.dataList);

            let data = Object.assign({}, state.brandInfo);
            data.dataList = [];
            Object.assign(data.dataList, dataList);
 */

            return ({
                ...state,
                esItemsBefore: data,
            })
        },
        [REQ_TYPE_LIST_ES_BEFORE_ADD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_LIST_ES_DONE_SUCCESS]: (state, { payload }) => {

            //console.log("before data = " + JSON.stringify(payload.data))
            //console.log("REQ_TYPE_LIST_ES_DONE_SUCCESS");
            state.esListDoneResult = payload.code;
            state.esItemsDone = payload.data.items;
            state.esItemsDoneCount = payload.data.totalcount;
            state.esDelListBeforeResult = null;
            return ({
                ...state,
            })
        },
        [REQ_TYPE_LIST_ES_DONE_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_LIST_ES_DONE_ADD_SUCCESS]: (state, { payload }) => {

            //console.log("before data = " + JSON.stringify(payload.data))
            //console.log("REQ_TYPE_LIST_ES_DONE_ADD_SUCCESS");
            state.esListDoneResult = payload.code;
            //state.esItemsDone = payload.data.items;
            state.esItemsDoneCount = payload.data.totalcount;
            state.esDelListBeforeResult = null;

            let dataList = state.esItemsDone.concat(payload.data.items);
            let data = Object.assign([], state.esItemsDone);
            
            Object.assign(data, dataList);

            //console.log("add data = " + JSON.stringify(data))

            return ({
                ...state,
                esItemsDone: data,
            })
        },
        [REQ_TYPE_LIST_ES_DONE_ADD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [ES_ITEM_ING_CHECK_SET]: (state, { payload: item }) => {
            
            return ({
                ...state,
                esItemCheck: item,
            })
        },
        [ES_ITEM_BEFORE_CHECK_SET]: (state, { payload: item }) => {

            return ({
                ...state,
                esItemCheckBefore: item,
            })
        },
        [REQ_TYPE_DEL_ES_BEFORE_SUCCESS]: (state, { payload }) => {
            let result = {code: payload.code, totalcount:payload.data.totalcount}
            state.esDelListBeforeResult = result;
            state.esListBeforeResult = payload.code;
            //state.esItemsBefore = payload.data;

            state.esItemsBefore.totalcount = payload.data.totalcount;

            //console.log("REQ_TYPE_DEL_ES_BEFORE_SUCCESS count = " + state.esItemsBefore.totalcount);
            //console.log("REQ_TYPE_DEL_ES_BEFORE_SUCCESS esItemsBefore = " + JSON.stringify(state.esItemsBefore));
            return ({
                ...state,
            })
        },
        [REQ_TYPE_DEL_ES_BEFORE_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [ES_ITEMS_BEFORE_SET]: (state, { payload: item }) => {

            return ({
                ...state,
                esItemsBefore: item,
            })
        },
        [ES_ITEMS_DEL_RESULT_RESET]: (state, { payload }) => {

            return ({
                ...state,
                esDelListBeforeResult: null,
            })
        },
        [REQ_ES_ST_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                esStItems: payload,
                error: null,
            })
        },
        [REQ_ES_ST_FAILURE]: (state, { payload: error }) => ({
            ...state,
            esStItems: [],
            error,
        }),
        [REQ_ES_PROD_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                esProdItems: payload,
                error: null,
            })
        },
        [REQ_ES_PROD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            esProdItems: [],
            error,
        }),
        [ES_ITEM_SET_CUR_IDX]: (state, { payload }) => {
            return ({
                ...state,
                curIdx: payload,
                error: null,
            })
        },
        [REQ_TYPE_LIST_ES_STATUS_SUCCESS]: (state, { payload }) => {

            //console.log("status data = " + JSON.stringify(payload.data))
            //console.log("REQ_TYPE_LIST_ES_STATUS_SUCCESS");
            
            state.esItemsStatus = payload;
            
            return ({
                ...state,
            })
        },
        [REQ_TYPE_LIST_ES_STATUS_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
    }
    , initialState);

export default esItemsReducer;
